import { styled, AppBar, Toolbar, IconButton, Typography } from "@mui/material";

export const AppBarStyled = styled(AppBar)<{ open: boolean }>`
  ${({ theme }) => `
    z-index: ${theme.zIndex.drawer + 1};
    transition: ${theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    })};
  `}

  ${({ open, theme }) =>
    open &&
    `
      margin-left: 240px;
      width: calc(100% - 240px);
      transition: ${theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      })};
    `}
`;

export const ToolbarStyled = styled(Toolbar)`
  padding-right: 24px;
`;

export const IconButtonStyled = styled(IconButton)<{ open: boolean }>`
  margin-right: 36px;

  ${({ open }) => open && `display: "none"`}
`;

export const TypographyStyled = styled(Typography)`
  flex-grow: 1;
`;
